export { default as ProductSubFAQ } from './ProductSubFAQ';
